module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.LiveshowCounterBanner":{"template":[{"value":"liveShowCounter","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107002},"path":"~.LiveshowCounterBanner","_fox_":1}],"embed.container":[{"value":"#liveshow-container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107003},"path":"~.LiveshowCounterBanner","_fox_":1}],"widgets.timer.embed.container":[{"value":".show-start-time","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107005},"path":"~.LiveshowCounterBanner","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/lsCounter.js
// module id = 1142
// module chunks = 4